'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function CartSection({
  className,
  children,
  title,
}: {
  className?: string;
  children: React.ReactNode;
  title?: string;
}) {
  const { t } = useTranslations();

  return (
    <section
      className={cn(
        'custom-section',
        'section-gap',
        'pb-16 pt-8 sm:pb-20 sm:pt-10 lg:pb-24 lg:pt-12',
        className,
      )}
    >
      <div className={cn('custom-container', 'relative flex items-center justify-center')}>
        <Heading title={title ? title : t('text163')} center />
      </div>
      {children}
    </section>
  );
}
